/* eslint-disable */

// Список стран, для которых выводится предупреждение МИД РФ о Ближнем Востоке.
// Чтобы включить/отключить предупреждение для конкретной страны — добавьте или удалите её ID.
const MID_WARNING_COUNTRIES = [];

let MidWarningView = Backbone.View.extend({
    events: {
        'click .close': 'closeWarning',
    },
    closeWarning: function () {
        this.hideWarning();
    },
    hideWarning: function () {
        this.$el.slideUp(300);
    },
    showWarning: function () {
        this.$el.slideDown(300);
    },
    searchDataChanged: function (event, searchData) {
        const countryIds = searchData.get('countries').pluck('id');
        const hasMiddleEastCountry = _.some(countryIds, function (id) {
            return _.contains(MID_WARNING_COUNTRIES, id);
        });

        if (hasMiddleEastCountry) {
            this.showWarning();
        } else {
            this.hideWarning();
        }
    },
    initModelEvents: function () {
        this.searchPageViewModel.on('change:searchData', $.proxy(this.searchDataChanged, this));
    },
    initialize: function (options) {
        this.searchPageViewModel = options.searchPageViewModel;
        this.initModelEvents();
    },
});

export default MidWarningView;
